// extracted by mini-css-extract-plugin
module.exports = {"subhead":"Subheader__subhead--1bhY1","bounce":"Subheader__bounce--3jbOo"};